// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/containers/MessageInput.css
// module id = 1152
// module chunks = 0